interface SelectionDimension {
  rectangleStart: number;
  rectangleEnd: number;
  selectionStart: number;
  selectionEnd: number;
}

interface RectangleSelection {
  x: SelectionDimension;
  y?: SelectionDimension;
}

/**
 * Determines if a rectangle is selected based on its position and the selection boundaries.
 * Y dimensions are optional to allow horizontal-only selection logic.
 */
export function isRectangleSelected({ x, y }: RectangleSelection) {
  const isOutOfVerticalBoundaries = y
    ? y.rectangleStart > y.selectionEnd || y.rectangleEnd < y.selectionStart
    : false;

  const isOutOfHorizontalBoundaries =
    x.rectangleStart > x.selectionEnd || x.rectangleEnd < x.selectionStart;

  return !isOutOfVerticalBoundaries && !isOutOfHorizontalBoundaries;
}
